import { FaPlus, FaSitemap } from "react-icons/fa";
import { AppModal } from "../../_CORE/APP/Templates/_UI/Modal/_index";
import { AppButton } from "../../_CORE/APP/Templates/_UI/Button/_index";
import "./_Styles/NestedVaultModal.css";

export const NestedVaultModal = ({
    isOpen = false,
    onClose,
    title = "Bóveda",
    description = "",
    parentTitle = "Registro principal",
    parentLabel = "Registro principal",
    childLabel = "hija",
    childCount = 0,
    addLabel = "Agregar hija",
    onAddChild,
    isChildFormOpen = false,
    children,
}) => (
    <AppModal
        isOpen={isOpen}
        onClose={onClose}
        isDismissible={!isChildFormOpen}
        size="full"
        className="LStudio__app_nested_vault_modal"
        title={title}
        description={description}
        footer={
            <AppButton variant="ghost" tone="neutral" onClick={onClose} isDisabled={isChildFormOpen}>
                Cerrar
            </AppButton>
        }>
        <div className="LStudio__app_nested_vault_workspace">
            <div className="LStudio__app_nested_vault_summary">
                <div>
                    <span className="LStudio__app_nested_vault_summary_icon"><FaSitemap /></span>
                    <span>
                        <strong>{parentTitle}</strong>
                        <small>
                            {parentLabel} · {childCount} {childLabel}{childCount === 1 ? "" : "s"}
                        </small>
                    </span>
                </div>
                {onAddChild && (
                    <AppButton size="sm" icon={<FaPlus />} onClick={onAddChild} isDisabled={isChildFormOpen}>
                        {addLabel}
                    </AppButton>
                )}
            </div>

            {childCount > 0 ? (
                <div className="LStudio__app_nested_vault_grid">
                    {children}
                </div>
            ) : (
                <div className="LStudio__app_nested_vault_empty">
                    <FaSitemap />
                    <strong>Todavía no hay hijas</strong>
                    <span>Agregá la primera desde esta Bóveda. El padre se mantiene abierto durante todo el proceso.</span>
                </div>
            )}
        </div>
    </AppModal>
);
